import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';

export const FormatCcExpirationModule = angular
    .module('app.components.creditCards.formatCcExpiration', [
        CreditCardUtilitiesServiceModule
    ]).factory('_Format', ($filter, $document, creditCardUtilities) => {
        var formats = {};

        var hasTextSelected = ($target) => {
            var ref;

            if (($target.prop('selectionStart') != null) &&
                $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
                return true;
            }

            if (typeof $document !== 'undefined' && $document !== null &&
                (ref = $document.selection) != null
                    && typeof ref.createRange === 'function'
                    && ref.createRange().text) {
                return true;
            }

            return false;
        };

        // expiry

        var restrictExpiry = (e) => {
            var $target;
            var digit;
            var value;

            $target = angular.element(e.currentTarget);
            digit = String.fromCharCode(e.which);

            if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                e.preventDefault();
                return;
            }

            if (hasTextSelected($target)) return;

            value = $target.val() + digit;
            value = value.replace(/\D/g, '');

            if (value.length > 6) {
                e.preventDefault();
            }
        };

        var formatExpiry = (e) => {
            var $target;
            var digit;
            var val;

            digit = String.fromCharCode(e.which);

            if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) {
                e.preventDefault();
                return;
            }

            $target = angular.element(e.currentTarget);
            val = $target.val() + digit;

            if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
                e.preventDefault();
                return $target.val(`0${val} / `);
            } else if (/^\d\d$/.test(val)) {
                e.preventDefault();
                return $target.val(` ${val} / `);
            }
        };

        var formatForwardExpiry = (e) => {
            var $target;
            var digit;
            var val;

            digit = String.fromCharCode(e.which);

            if (!/^\d+$/.test(digit) && !e.meta && e.keyCode >= 46) return;

            $target = angular.element(e.currentTarget);
            val = $target.val();

            if (/^\d\d$/.test(val)) {
                return $target.val(` ${val} / `);
            }
        };

        var formatForwardSlash = (e) => {
            var $target;
            var slash;
            var val;

            slash = String.fromCharCode(e.which);

            if (slash !== '/') return;

            $target = angular.element(e.currentTarget);
            val = $target.val();

            if (/^\d$/.test(val) && val !== '0') {
                return $target.val(`0${val} / `);
            }
        };

        var formatBackExpiry = (e) => {
            var $target;
            var value;

            if (e.meta) return;

            $target = angular.element(e.currentTarget);
            value = $target.val();

            if (e.which !== 8) return;

            if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) return;

            if (/\d(\s|\/)+$/.test(value)) {
                e.preventDefault();
                return $target.val(value.replace(/\d(\s|\/)*$/, ''));
            } else if (/\s\/\s?\d?$/.test(value)) {
                e.preventDefault();
                return $target.val(value.replace(/\s\/\s?\d?$/, ''));
            }
        };

        var parseExpiry = (value) => {
            if (value != null) {
                var obj = creditCardUtilities.parseExpiration(value);
                var expiry = new Date(obj.year, obj.month - 1);
                return $filter('date')(expiry, 'MM/yyyy');
            }
            return null;
        };

        var getFormattedExpiry = (value) => {
            if (value != null) {
                var obj = creditCardUtilities.parseExpiration(value);
                var expiry = new Date(obj.year, obj.month - 1);
                return $filter('date')(expiry, 'MM / yyyy');
            }
            return null;
        };

        formats.expiry = (elem, ctrl) => {
            elem.bind('keypress', restrictExpiry);
            elem.bind('keypress', formatExpiry);
            elem.bind('keypress', formatForwardSlash);
            elem.bind('keypress', formatForwardExpiry);
            elem.bind('keydown', formatBackExpiry);

            ctrl.$parsers.push(parseExpiry);
            ctrl.$formatters.push(getFormattedExpiry);
        };

        return (type, elem, ctrl) => {
            if (!formats[type]) {
                var types = Object.keys(formats);

                var errstr = `Unknown type for formatting: ${type}.`;
                errstr += `Should be one of: ${types.join(', ')}`;

                throw errstr;
            }
            return formats[type](elem, ctrl);
        };
    }).directive('paymentsFormat', ($window, _Format) => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, elem, attr, ctrl) => {
                _Format(attr.paymentsFormat, elem, ctrl);
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/creditCards/formatCcExpiration.directive.js